var React = require('react');

function Point (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.282 11.04c.195.274.409.535.64.778l4.306 5.242a1 1 0 001.545 0l4.357-5.297a7.04 7.04 0 00.538-.654l.09-.109h-.013a7 7 0 10-11.49 0H1.25l.032.04zM10 7a3 3 0 11-6 0 3 3 0 016 0z","fill":"#FFF","fillRule":"evenodd"}));
}

Point.defaultProps = {"viewBox":"0 0 14 18"};

module.exports = Point;

Point.default = Point;
